<ng-template [sbmodal]="'copyRestoreLinkModal'">
  <sb-custom-modal [templateId]="'copyRestoreLinkModal'">
    <div slot="body">
      <div class="row">
        <div class="col-12">
          <div class="tablewrap">
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{ 'lang.globals.user' | translate }}</p>
                <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                  {{ restoreUser.user.name }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{ 'lang.globals.restoreCode' | translate }}</p>
                <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                  {{ restoreUser.restoreCode }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-row bb">
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                <p class="w-100">{{ 'lang.globals.restoreLink' | translate }}</p>
                <p class="w-100 tr d-flex">
                  <a [href]="restoreUrl" class="font-weight-bold" target="_blank"
                     title="{{'lang.globals.restoreLink'}}">{{ restoreUrl }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tr">
            <button (click)="copyLinkToClipboard()" class="btn btn-default mr-2">
              <sb-icon icon="copy"></sb-icon>
              {{ 'lang.globals.copyRestoreLink' | translate }}
            </button>
            <button (click)="finish()" class="btn btn-primary">{{ 'lang.globals.close' | translate }}</button>
          </p>
        </div>
      </div>
    </div>
  </sb-custom-modal>
</ng-template>


<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="green"
    sbTooltip="{{ 'lang.globals.newUser' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'plus'"
    (click)="addUser()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.globals.userManagement' | translate}}"
  [itemsData]="users"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'users'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="blocked" [default]="null"
                                   [label]="'lang.globals.blocked' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>

      <sb-filter-section title="{{'lang.globals.client' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="clients" [endpoint]="api._admin_Client_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.userName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.lastName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.firstName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.email' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

     Table Body

------------------------------->
  <ng-template #tbody let-user>
    <tr>
      <td>
        {{ user?.id }}
      </td>
      <td>
        {{ user?.username }}
      </td>
      <td>
        {{ user?.lastname }}
      </td>
      <td>
        {{ user?.firstname }}
      </td>
      <td>
        {{ user?.email }}
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="user.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(user, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
